<template>
    <v-container >
      <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
            @change="changeReportType()" />
        </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('resaleYear')">
        <v-text-field class="input-text-size"
        v-model="criteria.resaleYear" label="Resale Year" />
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('printDetails')">
      <v-col cols="2">
        <v-checkbox
          v-model="criteria.printDetails"
          label="Print Details"
          class="input-text-size">
        </v-checkbox>
      </v-col>
      </v-row>

      <v-row class="elevation-1" v-if="showReportConfig('printOrder')">
        <v-col cols="12">
          <v-radio-group
            v-model="criteria.printOrder" row
            dense hide-details
            >
            <v-radio
              label="Print in Name Order"
              value="nameOrder"
              color="primary" />
            <v-radio
              label="Print in Parcel ID Order"
              value="parcelIdOrder"
              color="primary" />
          </v-radio-group>
        </v-col>
    </v-row>
    <v-row class="elevation-1" v-if="showReportConfig('sortOrder')">
        <v-col cols="12">
          <label class="input-text-size"> Sort Letters By: </label>
          <v-radio-group
            v-model="criteria.sortOrder" row
            dense hide-details
            >
            <v-radio
              label="Owner Name"
              value="ownerName"
              color="primary" />
            <v-radio
              label="Parcel ID"
              value="parcelId"
              color="primary" />
            <v-radio
              label="Tax ID"
              value="taxId"
              color="primary" />
          </v-radio-group>
        </v-col>
    </v-row>
    <v-row class="elevation-1" v-if="showReportConfig('sortBy')">
        <v-col cols="12">
          <label class="input-text-size"> Sort By: </label>
          <v-radio-group
            v-model="criteria.sortOrder" row
            dense hide-details
            >
            <v-radio
              label="Owner Name"
              value="ownerName"
              color="primary" />
            <v-radio
              label="Tax ID"
              value="taxId"
              color="primary" />
          </v-radio-group>
        </v-col>
    </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ReportChip from '../../../reports/ReportChip.vue';
import { getRawJwt } from '../../../../util/jwt';
import { resaleReportList, queryStringCalc } from './report-util';
import { getTaxYearStatus } from '../../common-utils/tax-common.util';

export default {
  name: 'Reports',
  components: {
    ReportChip,
  },
  data: () => ({
    taxYearRange: [],
    criteria: {
      resaleYear: null,
      printDetails: false,
      printOrder: 'nameOrder',
      sortOrder: 'ownerName',
    },
    reportConfig: {
      route: '',
      filters: {},
    },
  }),
  created() {
    this.initializeTaxYear();
  },

  computed: {
    reports() {
      return [
        ...resaleReportList(),
      ];
    },
    ...mapState({
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
    }),
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        devSetting: this.devSettingItem,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    showReportConfig(configField) {
      return this.reportConfig.filters[configField];
    },
    async initializeTaxYear() {
      const item = await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      const data = [];
      const taxYears = [];

      // eslint-disable-next-line array-callback-return
      item.map((val) => {
        data.push({
          taxYear: val,
        });
        taxYears.push(val);
      });
      this.taxYearsList = data;
      this.criteria.taxYears = taxYears;
      return data;
    },
    changeReportType() {
      this.criteria.resaleYear = this.resaleSettingItem.resaleSaleYear
        || getTaxYearStatus().currentTax;
    },
  },
};
</script>
